import MdrRoute from '@routes/mdr/routes/mdr.route'

const MdrPage = () => <MdrRoute />

export default MdrPage
